//@flow
/**
 * Client Actions
 * @module client/actions
 */
import ReactGA from 'react-ga'
import localforage from 'localforage'
import {
  FETCH_CLIENT_REQUEST,
  FETCH_CLIENT_PENDING,
  FETCH_CLIENT_SUCCESS,
  FETCH_CLIENT_FAILURE,
} from './reducer'
import socket from '../../socket'


const clientStore = localforage.createInstance({
  name: 'client',
})

// refetch the question from server just incase there is an update
/**
 * fetches client details
 * @memberof client/actions
 */
export const fetchClient = () => async (dispatch: Function) => {
  dispatch({
    type: FETCH_CLIENT_REQUEST,
  })
  // get the client from offline cache
  dispatch({
    type: FETCH_CLIENT_PENDING,
    payload: await clientStore.getItem('details'),
  })
  // refetch client from server for updates
  socket.emit('client:details', (err, clientDetails): void => {
    if (err) {
      return dispatch({
        type: FETCH_CLIENT_FAILURE,
        payload: err,
        error: true,
      })
    }
    clientStore.setItem('details', clientDetails)
    dispatch({
      type: FETCH_CLIENT_SUCCESS,
      payload: clientDetails,
    })
    ReactGA.event({
      category: 'Client',
      action: 'Accessed Client',
    })
  })
}



// WEBPACK FOOTER //
// ./src/state/client/actions.js